<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1">1. The Iron Horse Comes to the Waters of the Mighty Mississippi</a></p>
<p class="toc1"><a href="#/6chap2#chap2">2. “With the Wings of the Wind”</a></p>
<p class="toc1"><a href="#/7chap3#chap3">3. War Slows the March to the Western Sea</a></p>
<p class="toc1"><a href="#/8chap4#chap4">4. Drill, Ye Tarriers, Drill, While the Owners Take the Plunder</a></p>
<p class="toc1"><a href="#/9chap5#chap5">5. The Era of the Cowboy Is Born</a></p>
<p class="toc1"><a href="#/10chap6#chap6">6. The Great Race</a></p>
<p class="toc1"><a href="#/11chap7#chap7">7. First Travelers on the Transcontinental</a></p>
<p class="toc1"><a href="#/12chap8#chap8">8. Railroaders West</a></p>
<p class="toc1"><a href="#/13chap9#chap9">9. Exit the Land Grabbers, Enter the Stock Manipulators</a></p>
<p class="toc1"><a href="#/14chap10#chap10">10. Sitting Bull and the Northern Route</a></p>
<p class="toc1"><a href="#/15chap11#chap11">11. Elegance on the Western Rails</a></p>
<p class="toc1"><a href="#/16chap12#chap12">12. The Immigrant</a></p>
<p class="toc1"><a href="#/17chap13#chap13">13. Trampling the Frontier</a></p>
<p class="toc1"><a href="#/18chap14#chap14">14. The Iron Horse Assumes a Devil Image</a></p>
<p class="toc1"><a href="#/19page285#chap15">Notes</a></p>
<p class="toc1"><a href="#/20chap16#chap16">Bibliography</a></p>
<p class="toc1"><a href="#/21page305#chap17">Index</a></p>
<p class="toc1"><a href="#/22biography#biography">A Biography of Dee Brown</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?81cc735e